module.exports = __webpack_public_path__ + "static/Sonyax49-0b0f410ce36b0f245f839d4dce886d1a.png";